module.exports = __webpack_public_path__ + "img/innov-logomotion.738b846d.gif";